// cookies
import Cookies from 'js-cookie';

/**
 * Método que retorna o final do cartão do usuário,
 * caso ele esteja logado como cliente.
 */
export const getFinalCartaoUsuarioLogado = (userData) => {
  console.log('Entrou em getFinalCartaoUsuario em clienteService.js');
  console.log('userData: ');
  console.log(userData);

  // vamos verificar se está logado como cliente
  const perfilUsuario = userData.dadosPerfil.nome;
  console.log('Perfil do usuário: ');
  console.log(perfilUsuario);

  if(perfilUsuario != 'BAR CLIENTE'){
    return false;
  }

  const numeroCartao = userData.dadosCliente.numero_cartao;
  // Verifica se o número do cartão existe e tem pelo menos 4 dígitos
  if (!numeroCartao || numeroCartao.length < 4) {
    return ''; // ou algum valor de fallback
  }
  const finalCartao = numeroCartao.slice(-4); // pega os últimos 4 dígitos
  console.log('número do cartão: ');
  console.log(numeroCartao);
  console.log('final do cartão: ');
  console.log(finalCartao);
  return finalCartao;
}



/**
 * Método que verifica se o usuário está logado como cliente e, 
 * caso esteja, atualiza os cookies com os dados da sessão
 */
export const atualizarDadosClienteLogado = (userData) => {

  console.log('Entrou em atualizarDadosClienteLogado em clienteService.js ...');
  console.log('Vai verificar se o cliente está logado...');
  
  console.log('userData: ');
  console.log(userData);

  if(userData && userData.dadosPerfil && userData.dadosPerfil.nome == 'BAR CLIENTE'){
    // Aqui o cliente está logado
    console.log('Cliente está logado!!');

    const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin'));

    // Atualiza o dadosCheckin
    const dadosCheckinAtualizado = { ...dadosCheckin };
    dadosCheckinAtualizado.nome = userData.user.name;
    dadosCheckinAtualizado.email = userData.user.email;
    dadosCheckinAtualizado.numeroCpf = userData.dadosCliente.cpf;
    dadosCheckinAtualizado.numeroTelefone = userData.dadosCliente.telefone_celular;

    // atualiza os dados do checkin na sessão
    sessionStorage.setItem('dadosCheckin', JSON.stringify(dadosCheckinAtualizado));

    // Armazena as variáveis nos cookies
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 dias
    Cookies.set('dadosCheckin', JSON.stringify(dadosCheckinAtualizado), { expires: date });

    // // vamos setar as informações do usuário
    // setInformacoesUsuario({
    //   nome: userData.user.name,
    //   email: userData.user.email,
    //   // numeroMesa: '',
    //   // numeroComanda: '',
    //   numeroCpf: userData.dadosCliente.cpf,
    //   numeroTelefone: userData.dadosCliente.telefone_celular,
    // });

  } else {
    console.log('Cliente NÃO está logado!');
  }
}

